import React from 'react';

import { Stack, Text } from '@eluve/components';
import {
  useAppointmentStatus,
  useSummary,
} from '@eluve/frontend-appointment-hooks';
import { useTranslation } from '@eluve/i18n';

export const SummarizationErrorCard: React.FC = () => {
  const { t } = useTranslation();
  const appointmentStatus = useAppointmentStatus();
  const { isSummaryAvailable } = useSummary();

  if (isSummaryAvailable || appointmentStatus !== 'COMPLETED') {
    return null;
  }

  return (
    <Stack
      className="h-96 rounded-xl border bg-white"
      align="center"
      justify="center"
      gap={1}
    >
      <Text>{t('appointment.summarization.noSummaryAvailable')}</Text>
    </Stack>
  );
};
